export type HumanApprovalOption = 'auto' | 'always' | 'never';

export const APPROVAL_TO_VALUE: Record<HumanApprovalOption, boolean | null> = {
  auto: null,
  always: true,
  never: false,
};

export const toApprovalOption = (value?: boolean | null): HumanApprovalOption =>
  value === true ? 'always' : value === false ? 'never' : 'auto';

/** What "Auto" classifies on, per tool type. */
export type HumanApprovalToolType = 'api' | 'mcp' | 'composio' | 'open_connector';

type HumanApprovalWording = {
  autoKey: string;
  autoFallback: string;
  helpKey: string;
  helpFallback: string;
};

export const HUMAN_APPROVAL_WORDING: Record<HumanApprovalToolType, HumanApprovalWording> = {
  api: {
    autoKey: 'HUMAN_APPROVAL_AUTO',
    autoFallback: 'Auto (classify by method)',
    helpKey: 'HUMAN_APPROVAL_HELP',
    helpFallback:
      'Whether the agent must ask the user before running this tool. Auto asks only for APIs that change data (non-GET).',
  },
  mcp: {
    autoKey: 'HUMAN_APPROVAL_AUTO_MCP',
    autoFallback: 'Auto (classify by tool annotations)',
    helpKey: 'HUMAN_APPROVAL_HELP_MCP',
    helpFallback:
      "Whether the agent must ask the user before running a tool from this MCP server. Auto follows the server's own read-only/destructive annotations.",
  },
  composio: {
    autoKey: 'HUMAN_APPROVAL_AUTO_COMPOSIO',
    autoFallback: 'Auto (classify by action metadata)',
    helpKey: 'HUMAN_APPROVAL_HELP_COMPOSIO',
    helpFallback:
      'Whether the agent must ask the user before running an action from this connector. Auto asks for anything not marked read-only.',
  },
  open_connector: {
    autoKey: 'HUMAN_APPROVAL_AUTO_COMPOSIO',
    autoFallback: 'Auto (classify by action metadata)',
    helpKey: 'HUMAN_APPROVAL_HELP_COMPOSIO',
    helpFallback:
      'Whether the agent must ask the user before running an action from this connector. Auto asks for anything not marked read-only.',
  },
};
